import { AuthedUser } from '@/_types/common';
import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface AuthState {
  isAuthenticated: boolean;
  user: AuthedUser | null;
  status:
    | 'idle'
    | 'loading'
    | 'refreshing'
    | 'authenticated'
    | 'unauthenticated'
    | 'logged_out'
    | 'error';
  errorMessage?: string;
}

const initialState: AuthState = {
  isAuthenticated: false,
  user: null,
  status: 'idle',
  errorMessage: undefined,
};

const authSlice = createSlice({
  name: 'auth',
  initialState,
  reducers: {
    loginSuccess: (
      state,
      action: PayloadAction<{
        user: AuthedUser;
      }>
    ) => {
      state.isAuthenticated = true;
      state.user = action.payload.user;
      state.status = 'authenticated';
      state.errorMessage = undefined;
    },
    logout: (state) => {
      state.isAuthenticated = false;
      state.user = null;
      state.status = 'logged_out';
      state.errorMessage = undefined;
      if (typeof window !== 'undefined') {
        localStorage.removeItem('persist:auth');
      }
    },
    refreshTokenSuccess: (
      state,
      action: PayloadAction<{
        user?: AuthedUser;
      }>
    ) => {
      if (action.payload.user) {
        state.user = action.payload.user;
        state.isAuthenticated = true;
      }
      state.status = 'authenticated';
      state.errorMessage = undefined;
    },
    setRefreshStatus: (state, action: PayloadAction<AuthState['status']>) => {
      state.status = action.payload;
    },
    setError: (state, action: PayloadAction<string>) => {
      state.status = 'error';
      state.errorMessage = action.payload;
    },
    clearError: (state) => {
      if (state.status === 'error') {
        state.errorMessage = undefined;
        state.status = 'idle';
      }
    },
    setUnauthenticated: (state) => {
      state.isAuthenticated = false;
      state.status = 'unauthenticated';
      state.user = null;
      state.errorMessage = undefined;
    },
    setLoading: (state) => {
      state.status = 'loading';
      state.errorMessage = undefined;
    },
  },
});

export const {
  loginSuccess,
  logout,
  refreshTokenSuccess,
  setRefreshStatus,
  setError,
  clearError,
  setUnauthenticated,
  setLoading,
} = authSlice.actions;

export default authSlice.reducer;
